module.exports = __webpack_public_path__ + "static/media/buildings.20cd34c6.png";